import Core from "@/core/Core";

class ProductCodeMapping {
  public id: number;

  public productCodeKsz: string;
  public productCodeNmg: string;

  public hsCodeRu: string;
  public hsCodeUz: string;

  public entityTypeName = 'Связка продуктовых кодов';

  static fromServer(data: any, result = new ProductCodeMapping()): ProductCodeMapping {
    result.id = data.id;
    result.productCodeKsz = data.productCodeKsz;
    result.productCodeNmg = data.productCodeNmg;
    result.hsCodeRu = data.hsCodeRu;
    result.hsCodeUz = data.hsCodeUz;
    return result;
  }

  static fromNew(result = new ProductCodeMapping()) {
    return result;
  }

  toString() {
    return this.entityTypeName + (this.id !== undefined ? ` №${this.id}` : '');
  }

  validate(): boolean {
    /* У этой сущности обязательно должны быть заполнены 2 любых поля */
    let fieldsFilledCount = 0;

    if (Core.utils.isNullOrUndefined(this?.productCodeKsz) === false &&
      this.productCodeKsz.length > 0) {
      fieldsFilledCount += 1;
    }

    if (Core.utils.isNullOrUndefined(this?.productCodeNmg) === false &&
      this.productCodeNmg.length > 0) {
      fieldsFilledCount += 1;
    }

    if (Core.utils.isNullOrUndefined(this?.hsCodeRu) === false &&
      this.hsCodeRu.length > 0) {
      fieldsFilledCount += 1;
    }

    if (Core.utils.isNullOrUndefined(this?.hsCodeUz) === false &&
      this.hsCodeUz.length > 0) {
      fieldsFilledCount += 1;
    }

    return fieldsFilledCount > 1;
  }

}

export default ProductCodeMapping;
